import React from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { Row, Col } from "antd";
import FormInput from "components/FormItems/FormInput";
import AppButton from "components/AppButton/AppButton";

const CreditSchema = Yup.object().shape({
  credit: Yup.string().required("Credit is required!")
});

const CreditForm = props => {
  const { onClose, type, gateway, buttonMessage } = props;

  const onUpdateCredit = values => {
    const { user, onSubmit } = props;
    if (gateway) {
      onSubmit(user._id, { values, type }).then(() => onClose());
    } else {
      onSubmit(user._id, values).then(() => onClose());
    }
  };

  const initialValues = { credit: 0 };

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={CreditSchema}
        onSubmit={(values, { setSubmitting }) => {
          onUpdateCredit(values)
            .then(() => onClose())
            .finally(() => setSubmitting(false));
        }}
      >
        {({ handleSubmit, isSubmitting, handleChange, errors, values, touched }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <Row gutter={20}>
                <Col span={12}>
                  <FormInput placeholder={"Add Credit"} label={"Credit"} name={"credit"} onChange={handleChange} type={"number"} value={values.credit} error={errors.credit} touched={touched.credit} />
                </Col>
              </Row>
              <Row gutter={20}>
                <Col span={12}>
                  <AppButton label={buttonMessage} type="submit" light disabled={isSubmitting} />
                  <AppButton light withoutBg label="Close" type="button" className="ms-2" onClick={onClose} />
                </Col>
              </Row>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default CreditForm;
